<div class="object-new-copy-view">
  @for (selected of selectorContainer.searchContainer.searchResult.artifacts; track selected) {
    <div>
      @if (selected.artifact_id === selectorContainer.searchContainer.selections.selectedItems[0].artifact_id) {
        <span class="object-new-copy-view__copy-information">
          <span class="object-new-copy-view__copy-information-headline">
            <span>
              {{ 'TRANS__CREATE_NEW__COPY_HEADLINE' | translate }}
            </span>

            <span>
              {{ selected.artifact_name }}
            </span>
          </span>

          <p class="object-new-copy-view__copy-information-text">
            <span>
              {{ 'TRANS__CREATE_NEW__COPY_TEXT' | translate }}
            </span>

            @if (!createMultiple) {
              <span>
                {{ 'TRANS__CREATE_NEW__COPY_TEXT_MORE_INFO' | translate }}
              </span>
            }
            @else {
              <span>
                {{ 'TRANS__CREATE_NEW__COPY_MULTIPLE_TEXT_MORE_INFO' | translate }}
              </span>
            }
          </p>
        </span>
      }
    </div>
  }

  <div class="row object-new-copy-view__content">
    @if (object) {
      <app-object-edit
        [sectionsContainer]="sectionsContainer"
      ></app-object-edit>
    }
  </div>
</div>
